import PropTypes from 'prop-types';
import { useRouter } from 'next/router';

import { analytics, getFilterApply } from '@/utils/analytics';

import Text from '@/atoms/Text/Text';
import FilterDropdown from '@/molecules/FilterDropdown/FilterDropdown';
import { isWHEnv, getContent } from '@/utils/helper';

function Filters({ fields, entries }) {
  const { tagGroupsWithTags, queryTagsKey, name, tags } = fields;

  let tagGroupsWithTag = [];
  const groupTags =
    tags?.length > 0
      ? tags.map((tag) => {
          const tagContent = getContent(tag.sys.id, entries)?.fields;
          const tagGroup = getContent(tagContent.tagGroup.sys.id, entries)?.fields;

          if (tagGroupsWithTag.some(e => e.id === tagContent.tagGroup.sys.id)) {
            const index = tagGroupsWithTag.findIndex(e => e.id === tagContent.tagGroup.sys.id);
            tagGroupsWithTag[index].tags = [
              ...tagGroupsWithTag[index].tags,
              {
                id: tag.sys.id,
                name: tagContent.name,
                slug: tagContent.slug,
              }
            ]
          } else {
            tagGroupsWithTag.push({
              id: tagContent.tagGroup.sys.id,
              name: tagGroup.name,
              slug: tagGroup.slug,
              tags: [{
                id: tag.sys.id,
                name: tagContent.name,
                slug: tagContent.slug,
              }]
            })
          }
        })
      : [];

  //if there is no tagGroups found show nothing
  if (tagGroupsWithTags.length === 0) return null;

  const getApplyAnalytics = (searchUrl = '', e) => {
    const urlParams = searchUrl?.split(',');
    if (!tagGroupsWithTags?.length || !urlParams?.length) return;

    const activeTagGroups = tagGroupsWithTags.reduce(
      (activeGroup = {}, { name, tags }) => {
        if (!tags?.length) return activeGroup;

        const selectedTags = tags
          .filter(({ slug }) => urlParams.includes(slug))
          ?.map(({ slug }) => slug);

        return {
          ...activeGroup,
          [`filter_${name.toLowerCase().replace(/\s/, '_')}`]:
            selectedTags?.length ? selectedTags.join(',') : null,
        };
      },
      {}
    );

    analytics({
      window,
      document,
      detail: getFilterApply(e, activeTagGroups, { name }),
    });
  };

  return (
    <div className="aaco-filters container dd-kr:max-w-7xl dd-en:max-w-7xl dd-kr:px-0 dd-en:px-0 mx-auto flex flex-col md:flex-row md:items-center md:gap-x-7 md:py-9 md:px-16">
      <Text tag={isWHEnv() ? "body" : "tag"} style="dd-kr:text-dark-warm-grey dd-en:text-dark-warm-grey text-acacia mr-7 mb-5 md:mb-0">
        EXPLORE BY:
      </Text>
      {tagGroupsWithTag.map((i) => (
        <FilterDropdown
          key={i.id}
          name={i.name}
          slug={i.slug}
          tags={i.tags}
          queryTagsKey={queryTagsKey}
          getApplyAnalytics={getApplyAnalytics}
        />
      ))}
  </div>
);
}

Filters.propTypes = {
assets: PropTypes.array,
entries: PropTypes.array,
fields: PropTypes.object,
};

Filters.defaultProps = {
assets: [],
entries: [],
fields: null,
};

export default Filters;
